import React from "react";
import { Space } from "antd";
import { Link } from "react-router-dom";

const ICP_NUMBER = process.env.REACT_APP_ICP_NUMBER || "";

const SiteFooter = ({ compact = false }) => (
    <footer className={"site-footer" + (compact ? " compact" : "")}>
        <div>© {new Date().getFullYear()} 看屋子 · 深圳市正士吉商贸有限责任公司</div>
        <Space size={16} wrap>
            <Link to="/agreement">用户服务协议</Link>
            <Link to="/privacy">隐私政策</Link>
            {ICP_NUMBER && <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">{ICP_NUMBER}</a>}
        </Space>
    </footer>
);

export default SiteFooter;
